import { KvkkRequestViewModel } from '@api/index';

export const addRegistrationEventsToGTM = (action: string, label: string) => {
  dataLayer.push({
    Category: 'Membership',
    Action: action,
    Label: label,
    noninteraction: true,
    event: 'gaEvent',
  });
};

export const addSignUpSendEmailSuccessEventToGTM = ({
  isEmailConfirmed,
  isPhoneConfirmed,
  isSMSConfirmed,
}: KvkkRequestViewModel) => {
  const permissions = [];
  isSMSConfirmed && permissions.push('SMS');
  isPhoneConfirmed && permissions.push('Telefon');
  isEmailConfirmed && permissions.push('EPosta');

  dataLayer.push({
    Category: 'Membership',
    Action: 'Sign Up',
    Label: 'Step 2',
    cd_comm_permission: permissions.join('|') || 'None',
    noninteraction: true,
    event: 'gaEvent',
  });
};
